export default "__VITE_ASSET__f3d53e9c__"